import { render, staticRenderFns } from "./view.html?vue&type=template&id=2012c1a6&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=2012c1a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012c1a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2012c1a6')) {
      api.createRecord('2012c1a6', component.options)
    } else {
      api.reload('2012c1a6', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=2012c1a6&scoped=true&", function () {
      api.rerender('2012c1a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/box/exclusive/detail/index.vue"
export default component.exports